"use strict";

define('view/upload.manager',['marionette', 'backbone', 'underscore', 'uikit/mixins/component.mixin', 'uikit/elements/button', './empty.table', '../templates', 'FileAPI', 'backbone.radio'], function (Mn, Backbone, _, ComponentMixin, ButtonView, EmptyTableView, Templates, FileAPI, Radio) {
  var channel = Radio.channel('global');
  var FileModel = Backbone.Model.extend({}, {
    createFromFile: function createFromFile(file) {
      return new this({
        file: file,
        lastModified: file.lastModified,
        name: file.name,
        size: file.size,
        type: file.type
      });
    }
  });
  var DropModel = Backbone.Model.extend({});
  var DropItem = Mn.ItemView.extend({
    className: 'item',
    template: Templates.IRB['upload.drop.item'],
    attributes: {
      style: 'padding: 1em 0;'
    }
  });
  var EmptyView = Mn.ItemView.extend({
    attributes: {
      style: 'border-top: 1px solid rgba(39, 41, 43, 0.15); border-bottom: 1px solid rgba(39, 41, 43, 0.15); padding: 1em 0;'
    },
    template: function template() {
      return '<div style="text-align: center;">No Files</div>';
    }
  });
  var UploadItem = Mn.ItemView.extend(ComponentMixin).extend({
    tagName: 'tr',
    className: 'item',
    template: Templates.IRB['upload.item'],
    bindings: {
      name: 'name',
      url: 'url',
      icon: 'icon'
    },
    options: {
      name: '',
      url: '',
      icon: 'icon'
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.close = new ButtonView({
        icon: 'remove',
        inline: true,
        floated: 'right'
      }).on('press', function () {
        if (this._parent) {
          this._parent.collection.remove(this.model);
        }
      }, this);
    }
  });
  var UploadManager = Mn.CompositeView.extend(ComponentMixin).extend({
    className: 'content',
    template: Templates.IRB['upload.manager'],
    childViewContainer: '.ui.table',
    childView: UploadItem,
    getChildView: function getChildView(model) {
      if (model instanceof DropModel) {
        return DropItem;
      }
      return UploadItem;
    },
    emptyViewOptions: {
      icon: 'cloud upload',
      headerTag: 'h2',
      text: 'Add or drop files'
    },
    emptyView: EmptyTableView,
    options: {
      multiple: false,
      accept: null
    },
    ui: {
      file: '.file'
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.collection = new Backbone.Collection([], {
        model: FileModel
      });
      this.choose = new ButtonView({
        text: "Add",
        icon: 'plus',
        basic: true,
        fluid: true
      }).on('press', function () {
        channel.request('file:chooser', {
          multiple: this.multiple,
          accept: this.accept
        });
      }, this);
      this.listenTo(this.collection, 'add', this._addIconByType);
    },
    _addIconByType: function _addIconByType(model) {
      model.set('icon', channel.request('file:icon', model.get('file')));
    },
    onRender: function onRender() {
      var self = this;
      FileAPI.event.on(this.ui.file.get(0), 'change', function (evt) {
        self.processFiles(FileAPI.getFiles(evt));
      });
    },
    processFiles: function processFiles(files) {
      var models = [];
      FileAPI.each(files, function (file) {
        models.push(FileModel.createFromFile(file));
      });
      this.collection.add(models);
    }
  });
  UploadManager.DropModel = DropModel;
  return UploadManager;
});

